import React from "react";
import ReactApexCharts from "react-apexcharts";
import { Empty } from "antd";
import { FormatUSD } from "../../utils/helpers/string";
// import "./style.scss";

function CandleGraphs({ data, graphType, dataSymbol, title, ...props }) {
  const defaultData = { data: [], time: [] };
  const chartData = data?.data && data?.time ? data : defaultData;
  const seriesData = Array.isArray(chartData.data) ? chartData.data : [];

  // Calculate dynamic y-axis ticks based on data range
  const minValue = seriesData.length > 0 ? Math.min(...seriesData) : -100;
  const maxValue = seriesData.length > 0 ? Math.max(...seriesData) : 100;
  const range = Math.max(Math.abs(minValue), Math.abs(maxValue));
  const tickAmount = 8; // Number of ticks (including zero)

  const options = {
    series: [
      {
        name: graphType,
        data: seriesData,
      },
    ],
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
      background: "#030504",
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 800,
      },
    },
    grid: {
      show: true,
      borderColor: "#ffffff33",
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        colors: {
          ranges: [
            { from: -Infinity, to: 0, color: "#ff4d4f" },
            { from: 0, to: Infinity, color: "#4bb390" },
          ],
        },
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#75EBC3"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        opacityFrom: 0.34,
        opacityTo: 0.1,
        stops: [0, 100],
        colorStops: [
          { offset: 0, color: "#75EBC3", opacity: 0.34 },
          { offset: 100, color: "#75EBC3", opacity: 0.1 },
        ],
      },
    },
    dataLabels: { enabled: false },
    yaxis: {
      axisBorder: { show: false },
      min: -range,
      max: range,
      tickAmount: tickAmount,
      labels: {
        formatter: (value) => {
          if (isNaN(value) || value === undefined || value === null) return "";
          const fixedValue = dataSymbol === "percentage" ? value.toFixed(2) : value.toFixed(0);
          if (dataSymbol === "amount") return FormatUSD(fixedValue);
          if (dataSymbol === "percentage") return `${fixedValue}%`;
          return `${fixedValue}`;
        },
        style: {
          colors: "#b0b0b0",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
      title: {
        text: dataSymbol === "amount" ? "Amount ($)" : dataSymbol === "percentage" ? "Percentage (%)" : "Count",
        style: {
          color: "#b0b0b0",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
    },
    xaxis: {
      axisBorder: { show: false },
      type: "category",
      categories: Array.isArray(chartData.time) ? chartData.time : [],
      labels: {
        rotate: -45,
        style: {
          colors: "#b0b0b0",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
      title: {
        text: title,
        style: {
          color: "#b0b0b0",
          fontFamily: "Manrope, sans-serif",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
    },
    annotations: {
      yaxis: [
        {
          y: 0,
          borderColor: "#ffffff66",
          borderWidth: 1,
          strokeDashArray: 4,
          label: {
            show: false,
          },
        },
      ],
    },
    tooltip: {
      y: {
        formatter: (value) => {
          if (isNaN(value) || value === undefined || value === null) return "";
          if (dataSymbol === "amount") return FormatUSD(value);
          if (dataSymbol === "percentage") return `${value}%`;
          return `${value}`;
        }
      }
    },
  };

  return (
    <div className="chart-wrapper" {...props}>
      {seriesData.length > 0 ? (
        <ReactApexCharts
          options={options}
          series={options.series}
          type="bar"
          height="100%"
        />
      ) : (
        <div
          className="no-data-message"
          style={{
            height: "100%",
            minHeight: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty
            description={<span style={{ color: "#fff" }}>No Data Available</span>}
          />
        </div>
      )}
    </div>
  );
}

export default CandleGraphs;